import { render, staticRenderFns } from "./InvestLivingBenefit.vue?vue&type=template&id=24aaa836&scoped=true"
import script from "./InvestLivingBenefit.vue?vue&type=script&lang=js"
export * from "./InvestLivingBenefit.vue?vue&type=script&lang=js"
import style0 from "./InvestLivingBenefit.vue?vue&type=style&index=0&id=24aaa836&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24aaa836",
  null
  
)

export default component.exports